import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BaseService } from '../../services/base.service';
import { PopupService } from '../../services/popup.service';
import { MapService } from '../../services/map.service';
import { UserService } from '../../services/user.service';


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.less']
})
export class MapComponent implements OnInit {
  routerEventsSubscription: Subscription;
  routeParamsSubscription: Subscription;

  constructor(public router: Router, public activatedRoute: ActivatedRoute,
  	public popupService: PopupService, public baseService: BaseService,
    public mapService: MapService, public userService: UserService) { }

  ngOnInit() {
    this.onRouteChange();
    this.checkToTogglePopup();

    let searchInput = document.getElementById('pac-input');

    (<HTMLInputElement>searchInput).placeholder = 'Address, Neighborhood, City, or Zip';
    (<any>window).domBody.classList.remove('search-home');
    setTimeout(()=>{
      this.baseService.focusFirstEmptyElement('mystuff-input');
    },0);
  }

  onRouteChange() {
    this.routerEventsSubscription = this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
        this.checkToTogglePopup();
      }
    });
  }

  checkToTogglePopup() {
    this.routeParamsSubscription = this.activatedRoute.params.subscribe(params => {
      this.baseService.paramChangeSource.next(true);
      if(this.activatedRoute.firstChild) {
        this.popupService.togglePopup(this.activatedRoute.firstChild && this.activatedRoute.firstChild.snapshot.paramMap.get('popup'), 
                                    this.activatedRoute.firstChild && this.activatedRoute.firstChild.firstChild && this.activatedRoute.firstChild.firstChild.snapshot.paramMap.get('inner'), this.activatedRoute.firstChild && this.activatedRoute.firstChild.firstChild && this.activatedRoute.firstChild.firstChild.firstChild && this.activatedRoute.firstChild.firstChild.firstChild.snapshot.paramMap.get('subInner'));
      } else {
        this.popupService.togglePopup();
      }
    });
  }

  ngOnDestroy() {
    this.routeParamsSubscription && this.routeParamsSubscription.unsubscribe();
    this.routerEventsSubscription && this.routerEventsSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/map/map.component.ts